import { GIFT_CARD } from '@consts/index'
import currencyConverter from '@helpers/misc/currencyConverter'
import { ProductWithVariants } from 'types/product'
import FitOption from '@components/ui/FitOption'
import GiftCardAddToBasket from '../GiftCardAddToBasket'
import styles from './styles.module.scss'
import { AddToCartButtonProps } from '@components/product/AddToCartButton'

const priceValue = (value: string) => {
  return currencyConverter({ price: value, decimals: false })
}

type GiftCardAmountOptionsProps = {
  product: ProductWithVariants
  handleOnSelect: (value: string) => void
  selectedAmount: string
  handleAddItemToCart: AddToCartButtonProps['onAddToCart']
  name: string
}

const GiftCardAmountOptions = ({
  product,
  handleOnSelect,
  selectedAmount,
  handleAddItemToCart
}: GiftCardAmountOptionsProps) => {
  const { values } = GIFT_CARD
  const hasVariants = Number(product.variants?.length) > 1
  const hasSomeInventory =
    (hasVariants &&
      product.variants?.some(variant => !!variant.inventory_quantity)) ||
    false
  const hasSelectedOption =
    (hasVariants &&
      product.variants?.some(variant => {
        const optionAmount = variant.options.find(
          variant => variant.type === 'amount'
        )?.value
        return optionAmount === selectedAmount
      })) ||
    false

  return (
    <>
      <div className={`${styles.giftCard__options} options`}>
        {values.map((value, index) => {
          const isActive =
            hasVariants &&
            !!product.variants?.find(variant => {
              const optionAmount = variant.options.find(
                variant => variant.type === 'amount'
              )?.value
              return optionAmount === value && !!variant.inventory_quantity
            })
          return (
            <FitOption
              key={value}
              optionValue={priceValue(values[index])}
              classes={styles.giftCard__option}
              onSelect={() => handleOnSelect(value)}
              selected={selectedAmount === value}
              active={isActive}
            />
          )
        })}
      </div>
      <GiftCardAddToBasket
        active={hasVariants && hasSomeInventory && hasSelectedOption}
        handleOnClick={handleAddItemToCart}
        handle={product.handle}
      />
    </>
  )
}

export default GiftCardAmountOptions
